import React, { useCallback, useContext, useEffect, useState } from 'react'
import { numCol, strCol } from '@integec/grid-tools/lib/cols'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'

import { Button, DatePicker, Input, InputNumber, Select } from 'antd'
import {
  windStorageGroup,
  windStorageGroupHelper,
  windStorageGroupSave,
} from 'wind2/wind2api'
import R from 'ramda'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { toSelectionColProps } from '@integec/grid-tools'
import moment from 'moment'
import { renameWind2StorageGroup } from 'api/pgads'
import { RenameModal, HistoryModal } from 'wind2/wind2utils'
import { ErrorContext } from 'context'

const YNBooleanTypes = {
  Yes: 'Yes',
  N0: 'No',
}

const Wind2StroageGroup = ({ targetInfo }) => {
  const [storageType, setStorageType] = useState({})
  const [connectionType, setConnectionType] = useState({})
  const [manufacturer, setManufacturer] = useState({})
  const [invManufacturer, setInvManufacturer] = useState({})
  const [ownershipStatus, setOwnershipStatus] = useState({})
  const [entityMap, setEntityMap] = useState({})
  const [plantMap, setPlantMap] = useState({})
  const [showRenameModal, setShowRenameModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  const { setError } = useContext(ErrorContext)

  useEffect(
    _ => {
      windStorageGroupHelper(targetInfo).fork(
        _ => _,
        data => {
          let regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.storageType || []).map(d => ({
              [d.storageTypeCode]: d.storageTypeName,
            }))
          )
          setStorageType(regimeMap)

          regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.entity || []).map(d => ({
              [d.entityId]: d.entityId + ' - ' + d.entityName,
            }))
          )
          setEntityMap(regimeMap)

          regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.plants || []).map(d => ({ [d.plantId]: d.plantName }))
          )
          setPlantMap(regimeMap)

          regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.connectionType || []).map(d => ({
              [d.connectionTypeCode]: d.connectionTypeName,
            }))
          )
          setConnectionType(regimeMap)

          regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.manufacturer || []).map(d => ({
              [d.manufacturerCode]: d.manufacturerName,
            }))
          )
          setManufacturer(regimeMap)

          regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.invManufacturer || []).map(d => ({
              [d.manufacturerCode]: d.manufacturerName,
            }))
          )
          setInvManufacturer(regimeMap)

          regimeMap = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            (data.ownershipStatus || []).map(d => ({
              [d.ownershipStatusCode]: d.ownershipStatusName,
            }))
          )
          setOwnershipStatus(regimeMap)
        }
      )
    },
    [targetInfo]
  )

  const toMapSelect = values => {
    // const val = R.compose(
    //   R.fromPairs,
    //   R.map(d => [[id], d[id]])
    // )(values)
    // return val
    return values
  }
  const formatHeaders = Wind2StorageGroupHeaders.map(hdr =>
    hdr.ident === 'entityId'
      ? {
          ...hdr,
          dataFormatter: ({ value }) => entityMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            entityMap[rowData.entityId] || rowData.entityId,
          ...toSelectionColProps(toMapSelect(entityMap, 'entityId')),
        }
      : hdr.ident === 'plantId'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            plantMap[value] ? value + '-' + plantMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            plantMap[rowData.plantId] || rowData.plantId,
        }
      : hdr.ident === 'storageOwnershipStatus'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            ownershipStatus[value]
              ? value + '-' + ownershipStatus[value]
              : value,
          sortIndexGetter: ({ rowData }) =>
            ownershipStatus[rowData.storageOwnershipStatus] ||
            rowData.storageOwnershipStatus,
          ...toSelectionColProps(
            toMapSelect(ownershipStatus, 'ownershipStatusCode')
          ),
        }
      : hdr.ident === 'storageType'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            storageType[value] ? value + '-' + storageType[value] : value,
          sortIndexGetter: ({ rowData }) =>
            storageType[rowData.storageType] || rowData.storageType,
          ...toSelectionColProps(toMapSelect(storageType, 'storageTypeCode')),
        }
      : hdr === 'storageInvManufacturer'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            invManufacturer[value]
              ? value + '-' + invManufacturer[value]
              : value,
          sortIndexGetter: ({ rowData }) =>
            invManufacturer[rowData.storageInvManufacturer] ||
            rowData.storageInvManufacturer,
          ...toSelectionColProps(
            toMapSelect(invManufacturer, 'manufacturerCode')
          ),
        }
      : hdr === 'connectionType'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            connectionType[value] ? value + '-' + connectionType[value] : value,
          sortIndexGetter: ({ rowData }) =>
            connectionType[rowData.connectionType] || rowData.connectionType,
          ...toSelectionColProps(
            toMapSelect(connectionType, 'connectionTypeCode')
          ),
        }
      : hdr === 'storageManufacturer'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            manufacturer[value] ? value + '-' + manufacturer[value] : value,
          sortIndexGetter: ({ rowData }) =>
            manufacturer[rowData.storageManufacturer] ||
            rowData.storageManufacturer,
          ...toSelectionColProps(toMapSelect(manufacturer, 'manufacturerCode')),
        }
      : hdr
  )

  const [insertEvent, setInsertEvent] = useState(false)

  const Labeldiv = useCallback(({ id = '' }) => {
    const val = Wind2StorageGroupHeaders.find(f => f.ident === id) || {}
    const showAsterisk = !!(val.isPk || val.isKey || val.isRequired)
    return (
      <div
        style={{
          display: 'grid',
          alignContent: 'center',
          justifyContent: 'right',
        }}
      >
        {/* {val.isPk || val.isKey || val.isRequired ? '*' : ''} {val.display} : */}
        <div>
          {showAsterisk && (
            <span style={{ color: 'red', display: 'inline' }}>*</span>
          )}{' '}
          {val.display} :
        </div>
      </div>
    )
  }, [])
  const SelectComp = useCallback(
    ({ id, maps, insertData, setInsertData, extStyle = {} }) => {
      return (
        <React.Fragment>
          <Labeldiv id={id} />
          <Select
            value={insertData[id]}
            data-cy={id}
            onChange={e => setInsertData({ ...insertData, [id]: e })}
            style={{ ...extStyle, width: '100%' }}
          >
            {Object.keys(maps).map(k => (
              <Select.Option value={k} key={k} data-cy={id}>
                {maps[k]}
              </Select.Option>
            ))}
          </Select>
        </React.Fragment>
      )
    },
    []
  )

  const InputNumberComp = useCallback(
    ({ id, insertData, setInsertData, extStyle = {} }) => {
      return (
        <React.Fragment>
          <Labeldiv id={id} />
          <InputNumber
            value={insertData[id]}
            data-cy={id}
            onChange={e => setInsertData({ ...insertData, [id]: e })}
            style={{ ...extStyle, width: '100%' }}
          />
        </React.Fragment>
      )
    },
    []
  )

  const InputComp = useCallback(
    ({ id, insertData, setInsertData, extStyle }) => {
      return (
        <React.Fragment>
          <Labeldiv id={id} />
          <Input
            value={insertData[id]}
            data-cy={id}
            onChange={e =>
              setInsertData({ ...insertData, [id]: e.target.value })
            }
            style={{ ...extStyle, width: '100%' }}
          />
        </React.Fragment>
      )
    },
    []
  )

  const insertComp = ({
    insertData = {},
    setInsertData,
    onAdd,
    onCancel,
    // extStyle = {},
  }) => {
    return (
      <div
        style={{
          display: 'grid',
          // gridTemplateColumns:
          //   '210px 200px 200px 200px 250px 200px 280px 200px',
          gridTemplateColumns: '210px 200px 250px 200px 300px 200px',
          gap: 10,
          overflowY: 'auto',
        }}
      >
        <SelectComp
          id="entityId"
          maps={entityMap}
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <SelectComp
          id="plantId"
          maps={plantMap}
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <InputComp
          id="storageGroupId"
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <InputComp
          id="storageGroupName"
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <InputComp
          id="storageGroupEiaCode"
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <Labeldiv id="commisionDate" />
        <DatePicker
          allowClear={false}
          data-cy="commisionDate"
          value={
            insertData.commisionDateMod ||
            moment(insertData.commisionDate, 'YYYY-MM-DD')
          }
          format="MM/DD/YYYY"
          onChange={date =>
            setInsertData({
              ...insertData,
              commisionDate: date.format('YYYY-MM-DD'),
              commisionDateMod: date,
            })
          }
        />
        <Labeldiv id="effectiveDate" />
        <DatePicker
          allowClear={false}
          data-cy="effectiveDate"
          value={
            insertData.effectiveDateMod ||
            moment(insertData.effectiveDate, 'YYYY-MM-DD')
          }
          format="MM/DD/YYYY"
          onChange={date =>
            setInsertData({
              ...insertData,
              effectiveDate: date.format('YYYY-MM-DD'),
              effectiveDateMod: date,
            })
          }
        />
        <SelectComp
          id="storageOwnershipStatus"
          maps={ownershipStatus}
          insertData={insertData}
          setInsertData={setInsertData}
        />
        {/* <InputComp
          id="effectiveDate"
          insertData={insertData}
          setInsertData={setInsertData}
        /> */}
        <InputComp
          id="storageIsoResourceId"
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <SelectComp
          id="storageType"
          maps={storageType}
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <InputNumberComp
          id="nameplateCapacity"
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <InputNumberComp
          id="nameplateEnergy"
          insertData={insertData}
          setInsertData={setInsertData}
        />

        <Labeldiv id="chargeableFromGrid" />
        <Select
          value={insertData.chargeableFromGrid}
          data-cy="chargeableFromGrid"
          onChange={e =>
            setInsertData({ ...insertData, chargeableFromGrid: e })
          }
        >
          <Select.Option value="Yes" data-cy="chargeableFromGrid">
            Yes
          </Select.Option>
          <Select.Option value="No" data-cy="chargeableFromGrid">
            No
          </Select.Option>
        </Select>
        <SelectComp
          id="storageManufacturer"
          maps={manufacturer}
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <InputComp
          id="storageModel"
          insertData={insertData}
          setInsertData={setInsertData}
        />

        <SelectComp
          id="storageInvManufacturer"
          maps={invManufacturer}
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <SelectComp
          id="connectionType"
          maps={connectionType}
          insertData={insertData}
          setInsertData={setInsertData}
          extStyle={{ gridColumnEnd: 'span 3' }}
        />
        <InputComp
          id="storageInvModel"
          insertData={insertData}
          setInsertData={setInsertData}
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 10,
            gridColumnEnd: 'span 2',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }
  const sortOnData = data => {
    return data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
      commisionDate:
        d.commisionDate && moment(d.commisionDate).format('MM/DD/YYYY'),
    }))
  }

  const modifySaveDataBeforeSave = data => {
    return data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('YYYY-MM-DD'),
      commisionDate:
        d.commisionDate && moment(d.commisionDate).format('YYYY-MM-DD'),
    }))
  }

  const extraCriteriaAfterButton = ({
    data,
    onRetrieve,
    apiTargetInfo,
    setSpinning,
  }) => {
    return (
      <div>
        {showRenameModal && (
          <RenameModal
            list={data.map(e => ({
              label: e.storageGroupId,
              value: e.storageGroupId + '||' + e.plantId,
            }))}
            modalFor="Storage Group"
            hide={() => setShowRenameModal(false)}
            onOk={data => {
              const { oldId, newId } = data
              const ids = oldId?.split('||')

              setSpinning(true)
              renameWind2StorageGroup(apiTargetInfo)({
                oldId: ids[0],
                plantId: ids[1],
                newId,
              }).fork(setError, _ => {
                setSpinning(false)
                onRetrieve()
              })
            }}
          />
        )}
        {showHistoryModal && (
          <HistoryModal
            dataName="STORAGE GROUP"
            apiTargetInfo={apiTargetInfo}
            setError={setError}
            hide={() => setShowHistoryModal(false)}
          />
        )}
        <Button
          onClick={() => setShowRenameModal(true)}
          type="primary"
          // style={{ marginLeft: '10px' }}
        >
          Rename Storage Group
        </Button>
        <Button
          onClick={() => setShowHistoryModal(true)}
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          Show Rename History
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      sortOnData={sortOnData}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      title="Storage Group"
      header={formatHeaders}
      sortOptions={formatHeaders}
      saveTask={windStorageGroupSave('UPDATE')}
      retrieveTask={windStorageGroup}
      deleteTask={windStorageGroupSave('DELETE')}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={170}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={70}
      widthOffset={50}
      // heightOffset={100}
      defaultInsertData={{
        chargeableFromGrid: 'No',
        effectiveDateMod: moment(),
        effectiveDate: moment().format('YYYY-MM-DD'),
        commisionDateMod: moment(),
        commisionDate: moment().format('YYYY-MM-DD'),
      }}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2StroageGroup)

export const Wind2StorageGroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'storageGroupId',
    display: 'Storage Group ID',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'storageGroupName',
    display: 'Storage Group Name',
    isrRe: true,
    isRequired: 'asc',
    width: 250,
  }),
  strCol({
    ident: 'storageGroupEiaCode',
    display: 'Storage Group EIA Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'commisionDate',
    display: 'Commision Date',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'effectiveDate',
    display: 'Effective Date (mm/dd/yyyy)',
    sortOrder: 'asc',
    isRequired: true,
  }),
  strCol({
    ident: 'storageOwnershipStatus',
    display: 'Storage Ownership Status',
    sortOrder: 'asc',
    isRequired: true,
  }),

  strCol({
    ident: 'storageIsoResourceId',
    display: 'Storage Group ISO ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'storageType',
    display: 'Storage Type',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
    isRequired: 'asc',
  }),
  numCol({
    ident: 'nameplateCapacity',
    display: 'Nameplate Storage Capacity (MW)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
  }),
  numCol({
    ident: 'nameplateEnergy',
    display: 'Nameplate Generating Capacity (MWh)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
  }),
  strCol({
    ident: 'connectionType',
    display: 'Connection Type (AC/DC)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
  }),
  strCol({
    ident: 'chargeableFromGrid',
    display: 'Chargeable from Grid (Yes/No)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'storageManufacturer',
    display: 'Storage Manufacturer',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
  }),
  strCol({
    ident: 'storageModel',
    display: 'Storage Model',
    isFiltered: true,
    sortOrder: 'asc',
    isRequired: 'asc',
  }),

  strCol({
    ident: 'storageInvManufacturer',
    display: 'Storage Inverter Manufacturer',
    isFiltered: true,
    sortOrder: 'asc',
    isRequired: 'asc',
  }),
  strCol({
    ident: 'storageInvModel',
    display: 'Storage Inverter Model',
    isFiltered: true,
    sortOrder: 'asc',
    isRequired: 'asc',
  }),

  strCol({
    ident: 'transferToEntityId',
    display: 'Transfer to Entity ID',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, ellipsis: true }))
